import React, { useCallback, useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const purchases = [{
  name: 'Gastón L.',
  city: 'Córdoba',
  product: 'El Maestro de las Mamparas',
  time: 'hace 2 minutos'
}, {
  name: 'Emiliano R.',
  city: 'Mendoza',
  product: 'Pack Maestro Pro',
  time: 'hace 5 minutos'
}, {
  name: 'Julián S.',
  city: 'Rosario',
  product: 'El Maestro de las Mamparas',
  time: 'hace 8 minutos'
}, {
  name: 'Matías G.',
  city: 'Neuquén',
  product: 'Pack Maestro Pro',
  time: 'hace 12 minutos'
}, {
  name: 'Pablo P.',
  city: 'Buenos Aires',
  product: 'El Maestro de las Mamparas',
  time: 'hace 15 minutos'
}, {
  name: 'Nicolás D.',
  city: 'Tucumán',
  product: 'Pack Maestro Pro',
  time: 'hace 18 minutos'
}, {
  name: 'Sebastián M.',
  city: 'La Plata',
  product: 'El Maestro de las Mamparas',
  time: 'hace 22 minutos'
}, {
  name: 'Tomás A.',
  city: 'Salta',
  product: 'Pack Maestro Pro',
  time: 'hace 25 minutos'
}];
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showToast = useCallback(() => {
    setDismissed(false);
    setVisible(true);
    const hideTimer = setTimeout(() => setVisible(false), 6000);
    return hideTimer;
  }, []);
  useEffect(() => {
    const initialTimer = setTimeout(() => showToast(), 8000);
    return () => clearTimeout(initialTimer);
  }, [showToast]);
  useEffect(() => {
    if (!visible && !dismissed) {
      const nextTimer = setTimeout(() => {
        setIndex(prev => (prev + 1) % purchases.length);
        showToast();
      }, 45000);
      return () => clearTimeout(nextTimer);
    }
  }, [visible, dismissed, showToast]);
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    setTimeout(() => {
      setIndex(prev => (prev + 1) % purchases.length);
      setDismissed(false);
      showToast();
    }, 45000);
  };
  const purchase = purchases[index];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-418">
      <div className="bg-surface border border-white/10 rounded-xl p-4 shadow-2xl shadow-black/50" data-id="element-419">
        <div className="flex items-center justify-between mb-3" data-id="element-420">
          <div className="flex items-center gap-2" data-id="element-421">
            <span className="relative flex h-2.5 w-2.5" data-id="element-422">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-423"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold" data-id="element-424"></span>
            </span>
            <span className="text-gold text-xs font-bold uppercase tracking-wider" data-id="element-425">
              COMPRA VERIFICADA
            </span>
          </div>
          <button onClick={handleDismiss} className="text-gray-500 hover:text-white transition-colors p-0.5" aria-label="Cerrar" data-id="element-426">
            <XIcon className="w-4 h-4" data-id="element-427" />
          </button>
        </div>
        <p className="text-white text-sm mb-1" data-id="element-428">
          <span className="font-bold" data-id="element-429">{purchase.name}</span>
          <span className="text-gray-400" data-id="element-430"> de {purchase.city}</span>
        </p>
        <p className="text-gray-300 text-sm" data-id="element-431">
          compró{' '}
          <span className="text-gold font-semibold" data-id="element-432">{purchase.product}</span>
        </p>
        <p className="text-gold/70 text-xs mt-2" data-id="element-433">{purchase.time}</p>
      </div>
    </div>;
}